export const ReqEqColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'status', label: 'Status' },
  { key: 'jobId', label: 'Job Order #' },
  { key: 'vessel', label: 'Vessel' },
  { key: 'requestedBy', label: 'Requested By' },
];
